import React from "react";
import {RouteComponentProps} from 'react-router';
import {LoanData} from "../model/LoanData";
import {LoanDetailsTable} from "./loadn-details-table/LoanDetailsTable";
import {
    LoanNumberPromptInstructions
} from "../../loan_number_prompt/component/instructions/LoanNumberPromptInstructions";
import {LoanDetailsInstructions} from "./loan-details-instructions/LoanDetailsInstructions";
import {TileableComponent} from "../../../app/tileable/TileableComponent";
import {RedirectErrorBoundary} from "../../../app/error/RedirectErrorBoundary";
import "./LoanDetails.scss";
import {
    BrowserServiceSingleton,
    LoanDetailsServiceSingleton,
    PaymentServiceSingleton,
    SessionServiceSingleton
} from "src/Context";
import {FeeOptionKey} from "./FeeSelector";
import {LoanType} from "../model/LoanType";

interface Params {
    loanNumber: string;
}

interface State {
    loader: boolean;
    loanData?: LoanData;
    selectedFees?: FeeOptionKey[];
}

export class LoanDetails extends React.Component<RouteComponentProps<Params>, State> {

    private readonly loanDetailsService = LoanDetailsServiceSingleton;
    private readonly browserService = BrowserServiceSingleton;
    private readonly paymentService = PaymentServiceSingleton;
    private readonly sessionService = SessionServiceSingleton;

    constructor(props: any) {
        super(props);
        this.state = {
            loader: true,
        }
    }

    componentDidMount = () => {
        let loanNumber = this.props.match.params.loanNumber;
        this.loanDetailsService.loginByLoanNumber(loanNumber)
            .then(this.loanDetailsService.fetchLoanDetail)
            .then((loanData) => {
                this.setState({
                    loader: false,
                    loanData: loanData
                });
            })
            .catch(console.log);
    }

    proceedToPayment = () => {
        this.setState({loader: true})
        this.paymentService.fetchStatus()
            .then(info => this.sessionService.storePaymentInfo(info))
            .then(() => this.browserService.redirectTo(`/payment`));
    }

    creditCardProceedToPayment = (selectedFees?: FeeOptionKey[]) => {
        this.setState({loader: true})
        this.paymentService.fetchStatus()
            .then(info => this.sessionService.storePaymentInfo(info))
            .then(() => this.sessionService.storeSelectedFees(selectedFees || []))
            .then(() => this.browserService.redirectTo(`/payment`));
    }

    render() {
        const loanData = this.state.loanData;
        const shouldShowFeeSelector = !!(
            loanData
            && loanData.type === LoanType.CREDIT_CARD_LOAN
            && loanData.appraisalFeeEnabled
            && loanData.creditFeeEnabled
        );
        const containerClassName = `loan-details-container ${shouldShowFeeSelector ? "" : "loan-details-container--centered"}`.trim();

        return (
            <RedirectErrorBoundary>
                <TileableComponent instructions={this.getInstructions()}
                                   loaded={!this.state.loader}>
                    <div className={containerClassName}>
                        {this.getLoanDetailsTable()}
                    </div>
                </TileableComponent>
            </RedirectErrorBoundary>
        );
    }

    private getInstructions() {
        if (this.state.loanData != null) {
            let loan = this.state.loanData as LoanData;
            const selectedFees = this.sessionService.getSelectedFeesSafe();
            return <LoanDetailsInstructions loan={loan} selectedFees={selectedFees}/>
        } else {
            return <LoanNumberPromptInstructions/>
        }
    }

    private getLoanDetailsTable() {
        return <LoanDetailsTable loan={this.state.loanData as LoanData}
                                 proceedToPayment={this.proceedToPayment}
                                 creditCartProceedToPayment={this.creditCardProceedToPayment}/>
    }

}
